import { Paper, Stack } from "@mui/material";
import withDraggable from "hocs/withDraggable";
import { FieldArrayWithId, UseFieldArrayRemove } from "react-hook-form";
import { CompetencyMapInputs, KnowledgeBlockCompetencyOption, SkillsLiteralType } from "../types";
import Skill from "./Skill";

const SkillWithDraggable = withDraggable(Skill);

interface SkillsListProps {
  name: SkillsLiteralType;
  isEditable: boolean;
  removeSkill: UseFieldArrayRemove;
  skills: FieldArrayWithId<CompetencyMapInputs, SkillsLiteralType, "skillId">[];
  knowledgeBlock: KnowledgeBlockCompetencyOption;
}

const SkillsList = ({ name, isEditable, skills, knowledgeBlock, removeSkill }: SkillsListProps) => {
  if (!skills.length) return null;

  return (
    <Paper sx={{ backgroundColor: "transparent", boxShadow: "none", overflowY: "hidden", overflowX: "auto" }}>
      <Stack sx={{ minWidth: 650, pt: 1 }}>
        {skills.map((skill, index) => (
          <SkillWithDraggable
            isDragDisabled={!isEditable}
            draggableId={skill.skillId}
            key={skill.skillId}
            index={index}
            selectionEntity={skill.id ? { type: "skill", id: skill.id } : undefined}
            isEditable={isEditable}
            name={`${name}.${index}`}
            skill={skill}
            knowledgeBlock={knowledgeBlock}
            remove={() => removeSkill(index)}
            isLastField={index === skills.length - 1}
          />
        ))}
      </Stack>
    </Paper>
  );
};

export default SkillsList;
